module.exports = __webpack_public_path__ + "img/Art06-19970052-001.56f76707.jpg";